export default __webpack_public_path__ + "static/media/V880MAND4.12e84f2b.pdf";